import { MediaData, MediaType } from '@gripp/shared-logic';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { DocumentComponent } from './documentComponent';
import { ImageComponent } from './imageComponent';
import { LinkComponent } from './linkComponent';
import { MediaComponent, MediaComponentProps } from './types';
import { VideoComponent } from './videoComponent';

export type RenderMediaItemProps<T extends MediaData> =
  MediaComponentProps<T> & {
    canDelete?: boolean;
    deleteMediaItem?: (mediaId: string) => void;
    style?: ViewStyle;
    onPress?: () => void;
  };

const MediaComponents: Record<MediaType, MediaComponent<any>> = {
  [MediaType.Document]: DocumentComponent,
  [MediaType.Image]: ImageComponent,
  [MediaType.Link]: LinkComponent,
  [MediaType.Video]: VideoComponent,
  [MediaType.Audio]: () => null,
};

export const RenderMediaItem = <T extends MediaData>(
  props: RenderMediaItemProps<T>
) => {
  const Component = MediaComponents[props.mediaItem.type as MediaType];

  return (
    <View
      style={[
        props.canDelete && styles.mediaItemContainer,
        props.style,
      ]}
    >
      <Component {...props} />
    </View>
  );
};

const styles = StyleSheet.create({
  mediaItemContainer: {
    alignSelf: 'center',
    paddingRight: 10,
    paddingTop: 12,
  },
});
